/**
 * @generated SignedSource<<0b7b07a97b970c93493477ba58a2e1f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CateringEditForm_cateringOption$data = {
  readonly displayInSearch: boolean;
  readonly etgKey: string | null;
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentType": "CateringEditForm_cateringOption";
};
export type CateringEditForm_cateringOption$key = {
  readonly " $data"?: CateringEditForm_cateringOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"CateringEditForm_cateringOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CateringEditForm_cateringOption",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "etgKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayInSearch",
      "storageKey": null
    }
  ],
  "type": "CateringOption",
  "abstractKey": null
};

(node as any).hash = "c3eb665e564fc6f860275199da7a72d9";

export default node;
